// Module
var code = "<style>:host{display:flex;text-align:right;align-items:center;line-height:1em;flex-wrap:nowrap}#val:empty{min-width:48px}#units{display:flex;font-size:.75em;opacity:.7;white-space:pre}#units:not(:empty)::before{white-space:pre;content:\" \"}</style> <div id=\"val\"></div>";
// Exports
export default code;